import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import serverList from "../../components/serverList/serverOptions.vue";
import ShowUnionMsg from "./components/showUnionMsg.vue";
import infoList from "../../mixins/infoList";
import { unionList } from "@/api/union";
export default {
  components: {
    serverList: serverList,
    ShowUnionMsg: ShowUnionMsg
  },
  name: "gameItemConfig",
  mixins: [infoList],
  data: function data() {
    return {
      //分页
      listApi: unionList,
      searchInfo: {},
      dialogFormVisible: false,
      formData: {}
    };
  },
  methods: {
    queryEvent: function queryEvent() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getTableData();
            case 2:
              if (!_this.tableData || _this.tableData && _this.tableData.length === 0) {
                _this.$message({
                  message: "暂无数据"
                });
              }
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    EditUnionBtn: function EditUnionBtn(info) {
      this.formData.serverId = info.serverId;
      this.formData.unionId = info.unionId;
      this.dialogFormVisible = true;
    },
    backMsg: function backMsg(e) {
      this.dialogFormVisible = e;
    },
    openPop: function openPop() {
      this.$notify({
        title: "道具配置",
        dangerouslyUseHTMLString: true,
        message: "<div>(1)工会</div>",
        duration: 0
      });
    }
  }
};